/* Elenco reale delle strategie del motore, nell'ordine in cui il prototipo lo
 * dichiara. Serve a `SemBotIcon.setNames`: le famiglie e i colori delle icone
 * sono dedotti dall'INSIEME dei nomi, non da un nome alla volta, quindi
 * registrare un elenco parziale cambierebbe il colore di icone già viste.
 *
 * Va sostituito dall'elenco che arriva dal backend appena esiste un endpoint
 * che lo espone (vedi RICHIESTE-API.md): finché è scritto qui, aggiungere una
 * strategia al motore non si riflette nell'interfaccia.
 */
export const NOMI_STRATEGIE: readonly string[] = [
  'AdaptiveMultiFactor',
  'AdvancedEMAVolume',
  'AdvancedEMAVolumeTS',
  'BuyHoldRegime',
  'Coppock',
  'DEBUG',
  'DonchianBreakout',
  'DoubleSEM',
  'EMACross',
  'GrokOracle',
  'MACDCCI',
  'MACDEMA',
  'RocRsi',
  'RSI2MeanReversion',
  'RSIBollingerBands',
  'RSIBullBear',
  'RSIBullBearATR',
  'RSIBullBearDouble',
  'RSIBullBearLegacy',
  'RsiCrossover',
  'RSITakeProfit',
  'ScalpingDoubleBollingerBands',
  'SEM',
  'SEM2',
  'SEM3',
  'SEM26A',
  'SEM26B',
  'SEM26C',
  'SEM26C2',
  'SEM26C3',
  'SEM26CROCRSI',
  'SEM26D',
  'SEM26E',
  'SEM26F',
  'SEMBB',
  'SEMCCI',
  'SEMCD',
  'SEMCOPPOCK',
  'SemFlash',
  'SemFlash2',
  'SEMFlow',
  'SEMJ',
  'SEMMACD',
  'SEMMACD26',
  'SEMMACDX',
  'SEMMAX26',
  'SEMMFI',
  'SEM_OUT',
  'SEMProactive',
  'SEMQuota26',
  'SEMRegime',
  'SEMRegimeATR',
  'SEMSTOC',
  'SEMX1',
  'SEMX2',
  'SEMX3',
  'SEMX4',
  'SEMX5',
  'SMACross',
  'SMACross3',
  'SMACrossVROC',
  'SMACrossVRSI',
  'SMARSI',
  'TraDino',
  'WMACrossoverSwing',
];
